import React, {Component} from 'react';
import PropTypes from 'prop-types';
import EditHistory from './EditHistory';
import Confirmation from './Confirmation';
import AmplitudePicker from './AmplitudePicker';
import SpreadPicker from './SpreadPicker';
import EraseBoostPicker from './EraseBoostPicker';
import ZoomPanModePicker from './ZoomPanModePicker';
import PaintModePicker from './PaintModePicker';
import Mousetrap from 'mousetrap';

export const EDIT_POPPED_IMAGE_CONFIRMATION_MODAL = 'editPoppedImageConfirmationModal';
// todo: import these from styles css
export const PANEL_WIDTH = 95;

export default class ControlPanel extends Component {
    static propTypes = {
        imageInfo: PropTypes.object,
        spread: PropTypes.number,
        amplitude: PropTypes.number,
        edits: PropTypes.array,
        tool: PropTypes.string,
        shape: PropTypes.string,
        brushSize: PropTypes.number,
        eraseBoostLevel: PropTypes.number,
        onModal: PropTypes.func,
        history: PropTypes.object,
        lastFinishedId: PropTypes.number,
        onToolChanged: PropTypes.func,
        onResetView: PropTypes.func,
        onHistoryToggleVisible: PropTypes.func,
        onDeleteHistoryItem: PropTypes.func,
        onResetHistory: PropTypes.func,
        onUndoResetHistory: PropTypes.func,
        onUndoDeleteHistoryItem: PropTypes.func,
        onHistoryHighlightItem: PropTypes.func,
        onBrushSizeChange: PropTypes.func,
        onBrushCycle: PropTypes.func,
        onLassoCycle: PropTypes.func,
        onEraseBoostLevelChange: PropTypes.func,
        onAmplitudeOrScaleChange: PropTypes.func,
        hasUndoReset: PropTypes.bool,
        hasUndoDelete: PropTypes.bool,
        height: PropTypes.number,
    };

    componentDidMount() {
        Mousetrap.bind('.', (e) => {
            e.preventDefault();
            this.handleResetTool();
        });
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.lastFinishedId !== nextProps.lastFinishedId) {
            this.promptEditPoppedImage();
        }
    }

    componentWillUnmount() {
        // noinspection JSUnresolvedFunction
        Mousetrap.unbind(['.']);
    }

    promptEditPoppedImage = () => {
        this.props.onModal(EDIT_POPPED_IMAGE_CONFIRMATION_MODAL, true);
    };

    handleEditPoppedImage = () => {
        this.props.history.push(`/image/${this.props.lastFinishedId}`);
    };

    handleAmplitudeChange = (val) => {
        this.props.onAmplitudeOrScaleChange(this.props.imageInfo.id, {amplitude: val, spread: this.props.spread});
    };

    handleSpreadChange = (val) => {
        this.props.onAmplitudeOrScaleChange(this.props.imageInfo.id, {amplitude: this.props.amplitude, spread: val});
    };

    handleCloseEditor = () => {
        this.props.history.push(`/image/${this.props.imageInfo.id}`);
    };

    handleManagePresets = () => {
        this.props.history.push('/presets');
    };

    handleResetTool = () => {
        this.props.onToolChanged(null);
    };

    render() {
        const {
            amplitude, spread, edits, tool, shape, brushSize, eraseBoostLevel,
            hasUndoReset, hasUndoDelete,
        } = this.props;
        const {
            onToolChanged,
            onResetView,
            onHistoryToggleVisible,
            onDeleteHistoryItem,
            onResetHistory,
            onUndoResetHistory,
            onUndoDeleteHistoryItem,
            onHistoryHighlightItem,
            onBrushSizeChange,
            onBrushCycle,
            onLassoCycle,
            onEraseBoostLevelChange,
            height,
        } = this.props;

        return (
            <div className="control-panel">
                <ZoomPanModePicker mode={tool} onModeChanged={onToolChanged} onResetView={onResetView}/>
                <div className="amplitude-spread-picker">
                    <AmplitudePicker amplitude={amplitude} onChange={this.handleAmplitudeChange}/>
                    <SpreadPicker spread={spread} onChange={this.handleSpreadChange}/>
                </div>
                <EraseBoostPicker eraseBoostLevel={eraseBoostLevel} onChange={onEraseBoostLevelChange}/>

                <PaintModePicker
                    mode={tool}
                    shape={shape}
                    onModeChanged={onToolChanged}
                    onBrushSizeChange={onBrushSizeChange}
                    brushSize={brushSize}
                    onBrushCycle={onBrushCycle}
                    onLassoCycle={onLassoCycle}
                />
                <EditHistory
                    history={edits || []}
                    onToggleVisible={onHistoryToggleVisible}
                    onDelete={onDeleteHistoryItem}
                    onReset={onResetHistory}
                    onUndoReset={onUndoResetHistory}
                    onUndoDelete={onUndoDeleteHistoryItem}
                    onHighlightHistoryItem={onHistoryHighlightItem}
                    hasUndoReset={hasUndoReset}
                    hasUndoDelete={hasUndoDelete}
                    rightAlignMenu={true}
                    height={height}
                />

                <Confirmation name={EDIT_POPPED_IMAGE_CONFIRMATION_MODAL} onConfirm={this.handleEditPoppedImage} component={null}>
                    {'Close the current image and open the newly popped one?'}
                </Confirmation>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ControlPanel.js